<template>
	<div class="main_box">
		<MenuComponent/>
		<FirstScreenComponent/>
		<GalleryComponent/>
		<ServicesComponent/>
		<BookingComponent/>
		<HousingOptionsComponent/>
		<AmoFormComponent/>
		<SimpleGalleryComponent/>
		<FeedbackComponent/>
		<FooterComponent/>
	</div>
</template>

<script>
import MenuComponent from '../components/NavigationComponent.vue'
import FirstScreenComponent from '../components/FirstScreenComponent.vue'
import GalleryComponent from '../components/GalleryComponent.vue'
import ServicesComponent from '../components/ServicesComponent.vue'
import BookingComponent from '../components/BookingComponent.vue'
import HousingOptionsComponent from '../components/HousingOptionsComponent.vue'
import AmoFormComponent from '../components/AmoFormComponent.vue'
import SimpleGalleryComponent from '../components/SimpleGalleryComponent.vue'
import FeedbackComponent from '../components/FeedbackComponent.vue'
import FooterComponent from '../components/FooterComponent.vue'

export default {
	name: "MainComponent",
	metaInfo: {
		title: 'Загородный комплекс «Планета Дельфинов» | Dolphin Planet — отель и SPA',
		meta: [
			{name: 'theme-color', content: '#F7F3ED'},
			{name: 'apple-mobile-web-app-capable', content: 'yes'},
			{name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent'},

			{hid: 'url', name: 'url', content: 'http://dolphin-hotel.ru'},
			{hid: 'image', name: 'image', content: 'http://dolphin-hotel.ru/hr-161-iz-166.jpg'},
			{vmid: 'title', property: 'title', content: 'Загородный комплекс «Планета Дельфинов» | Dolphin Planet — отель и SPA'},
			{vmid: 'description', property: 'description', content: 'Территория истинного счастья в которой есть все необходимое для отдыха и развлечений. Большое количество дополнительных услуг и специальных предложений превращают каждое посещение комплекса в незабываемое приключение.'},
			{vmid: 'og:description', property: 'og:description', content: 'Территория истинного счастья в которой есть все необходимое для отдыха и развлечений. Большое количество дополнительных услуг и специальных предложений превращают каждое посещение комплекса в незабываемое приключение.'},

			{hid: 'og:url', name: 'og:url', content: 'http://dolphin-hotel.ru'},
			{hid: 'og:type', name: 'og:type', content: 'website'},
			{hid: 'og:title', name: 'og:title', content: 'Загородный комплекс «Планета Дельфинов» | Dolphin Planet — отель и SPA'},
			{hid: 'og:desc', name: 'og:description', content: `Территория истинного счастья в которой есть все необходимое для отдыха и развлечений. Большое количество дополнительных услуг и специальных предложений превращают каждое посещение комплекса в незабываемое приключение.`},
			{hid: 'og:image', name: 'og:image', content: 'http://dolphin-hotel.ru/hr-161-iz-166.jpg'},
		],
	},
	components: {
		MenuComponent,
		FirstScreenComponent,
		GalleryComponent,
		ServicesComponent,
		BookingComponent,
		HousingOptionsComponent,
		AmoFormComponent,
		SimpleGalleryComponent,
		FeedbackComponent,
		FooterComponent,
	},
}
</script>

<style scoped>
	.main_box {
		display: flex;
		flex-flow: row wrap;
		position: relative;
		/*background: grey;*/
		width: 100%;
		height: 100%;
		/*box-shadow: 0 0 10px darkgrey;*/
		overflow: hidden;
		background-color: #F7F3ED;
	}
	/*.main_box > div {*/
	/*	border-bottom: 1px dashed #4f4f4f;*/
	/*	width: 100% !important;*/
	/*	overflow: hidden;*/
	/*}*/
</style>